import {Component, ElementRef, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {WalletService} from "../wallet/wallet.service";
import {ToastrService} from "ngx-toastr";
import {AccountService} from "../account/account.service";
import {CryptomoedaService} from "./cryptomoeda.service";
import {AuthService} from "../../shared/services/auth.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-cryptomoeda',
  templateUrl: './cryptomoeda.component.html',
  styleUrls: ['./cryptomoeda.component.scss']
})
export class CryptomoedaComponent {
  crypto = new FormGroup({
    symbol: new FormControl<string>('',Validators.required),
    wallet: new FormControl<string>('',Validators.required),
    value: new FormControl<number | null>(null,[Validators.required]),
    cryptoValue: new FormControl<number>(0),
  });

  public cryptos: any;
  public isInsert: boolean;
  public isSubmitted: boolean;
  public isLoaded: boolean;
  public symbols: any;
  public wallets: any;
  public saldoDisponivel: number = 0;
  public cryptoTaxValue: number = 0;
  public cryptoTaxPercent: number = 0;
  public placeholderValue: string;
  public price: number = 0;
  public valorTotal: number = 0;
  public errorMessage: string;
  public validationCode: string;
  public page: number = 1;
  public pageSize: number = 10;
  public total: number = 0;
  public validatingTotp: boolean = false;

  @ViewChild('requestTOTPCode') validateToken : ElementRef | any;

  constructor(private walletService: WalletService,
              private accountService : AccountService,
              private cryptoMoedaService: CryptomoedaService,
              private toastr: ToastrService,
              private authService: AuthService,
              private modalService: NgbModal)
  {
    this.isInsert = false;
    this.isSubmitted = false;
    this.isLoaded = false;
    this.getCryptoMoedaTransactions();
    this.placeholderValue = '';
    this.errorMessage = '';
    this.validationCode = '';
  }

  async pasteTotpCode(): Promise<void> {
    try {
      this.validationCode = (await navigator.clipboard.readText()).trim();
    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  getCryptoMoedaTransactions(){
    this.isLoaded = false;
    this.cryptoMoedaService.getCryptoTransactions(this.page, this.pageSize).subscribe(
      value => {
        this.cryptos = value[0].cryptotransaction;
        this.total = value[0].total;
        this.isLoaded = true;
      }
    );
  }

  pageChange(){
    this.getCryptoMoedaTransactions();
  }

  getAccountValues(){
    this.accountService.getAccount().then(
      value => {
        this.saldoDisponivel = value.readyAmount;
        this.cryptoTaxValue = value.cryptoTaxValue;
        this.cryptoTaxPercent = value.cryptoTaxPercent;
        this.getPlaceHolder();
      }
    );
  }

  formatStatusClass(status: string): string {
    return 'status-' + status.toLowerCase().replace(/ /g, '-');
  }

  getPlaceHolder(){
    let valorDisponivel = this.saldoDisponivel;
    let placeholderValue = (valorDisponivel - this.cryptoTaxValue) / (1 + (this.cryptoTaxPercent / 100));

    this.placeholderValue = Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(placeholderValue);
  }

  getPrice() {
  this.isLoaded = false;
  const valor = this.crypto.controls.value.value;
  if(valor == null || valor == 0)
  {
    this.price = 0;
    this.isLoaded = true;
    return;
  }

  const symbolId = this.crypto.controls.symbol.value;
  if(symbolId){
    const selectedSymbol = this.symbols.find((symbol: { id: any; }) => symbol.id === symbolId);
    if(selectedSymbol){
      const symbol = selectedSymbol.name;
      this.cryptoMoedaService.getPriceBySymbol(symbol, symbolId, valor).subscribe(
        value => {
          this.price = value.data.quotePrice;
          this.crypto.controls.cryptoValue.setValue(this.price);
          this.isLoaded = true;
        },(error) => {
          this.toastr.error(error.error.mensagem ,'Erro',{
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.isLoaded = true;
        })
    }
  }
}

  loadSymbols() {
    this.isLoaded = false;

      this.walletService.getSymbols().subscribe(symbols => {
        const origem = this.authService.getOriginCurrency();

        this.symbols = symbols.filter((s: any) => s.originCurrency === origem);

        this.isLoaded = true;
      });
  }

  loadWallets(){
    this.crypto.controls.wallet.setValue('');
    this.isLoaded = false;
    let symbolId = this.crypto.controls.symbol.value!;
    if(symbolId != ''){
      this.walletService.getEnabledWallets(symbolId).subscribe(
        value => {
          this.wallets = value;
          this.isLoaded = true
        }
      );
    }
  }

  async openWithdraw() {
    let validatePeriod = await this.validatePeriod();
    if(!validatePeriod){
      this.toastr.error('Transações de criptomoedas são permitidas apenas de segunda a sexta das 09:00 às 17:00','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
      return;
    }

    this.isInsert = true;
    this.getAccountValues();
    this.loadSymbols();
    this.loadWallets();
    this.getPrice();
  }

  return() {
    this.isInsert = false;
    this.clearForm();
    this.getCryptoMoedaTransactions();
  }

  clearForm(){
    this.crypto.controls.symbol.setValue('');
    this.crypto.controls.wallet.setValue('');
    this.crypto.controls.value.setValue(null);
    this.crypto.controls.cryptoValue.setValue(0);

    this.crypto.controls.symbol.setErrors(null);
    this.crypto.controls.wallet.setErrors(null);
    this.crypto.controls.value.setErrors(null);
    this.crypto.controls.cryptoValue.setErrors(null);
    this.isSubmitted = false;
  }

  withdraw() {
    this.isLoaded = false;
    this.isSubmitted = true;

    if(this.authService.isReadOnly()){
      this.toastr.error('Seu usuário não tem permissão para realizar essa operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    if(this.crypto.valid && this.valorTotal > this.saldoDisponivel){
      this.toastr.error('Valor excede o saldo + taxas administrativas','Erro',
      {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
      return;
    }

    if(this.crypto.valid)
    {
      this.modalService.open(this.validateToken, {backdrop: "static", keyboard: true, centered: true, size: 'sm'});
    }

    this.isLoaded = true;
  }

  async validatePeriod(): Promise<boolean>
  {

    let accountValidatePeriod = true;
    await lastValueFrom(this.cryptoMoedaService.canMakeCryptoTransactionWithoutHour()).then(value =>
      {
        accountValidatePeriod = value
      });

    if(!accountValidatePeriod){
      return true;
    }

    let now = new Date();
    let diaSemana = new Intl.DateTimeFormat('pt-BR', {weekday: 'long'}).format(now);
    let hora = new Intl.DateTimeFormat('pt-BR', {hour: "numeric", hour12: false}).format(now);

    let diaDaSemana = (diaSemana !== 'domingo' && diaSemana !== 'sábado');
    let horaValida = parseInt(hora) >= 9 && parseInt(hora) < 17;

    return diaDaSemana && horaValida;
  }

  valorChanged() {
    this.getPrice();
    let valor = Number(Number(this.crypto.controls.value.value).toFixed(2));
    let taxa = ( valor * this.cryptoTaxPercent) / 100;
    taxa = Number(taxa.toFixed(2)) + this.cryptoTaxValue;
    this.valorTotal = valor > 0 ? (valor + taxa) : 0;
  }

  async validateTotp() {
    if (this.validatingTotp) {            
      return;
    }

    this.validatingTotp = true;

    if(await this.isValidTotp()){
      this.isLoaded = false
      this.modalService.dismissAll();
      let transaction = {
        symbolId : this.crypto.controls.symbol.value,
        walletId: this.crypto.controls.wallet.value,
        brlValue: this.crypto.controls.value.value,
      }
      lastValueFrom(this.cryptoMoedaService.addCryptoTransaction(transaction))
      .then(value => {
        this.toastr.warning(value.message,'Sucesso',{
          timeOut: 3000,
          positionClass: 'toast-center-center',
        });
        this.clearForm();
        this.isLoaded = true;
        this.isSubmitted = false;
      }, (error) => {
        this.toastr.error(error.error.mensagem ,'Erro',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        this.isLoaded = true;
        this.validatingTotp = false;
      })
    }else{
      this.errorMessage = 'Código de autenticação inválido!';
      this.validatingTotp = false;
    }
  }

  async isValidTotp()
  {
    let isValid: boolean = false;
    await this.authService.validateTotpCode(this.validationCode).then(
      value => {
        isValid = value.isValid;
      }
    );
    return isValid;
  }

  copyTxid(txid: string): void {
    navigator.clipboard.writeText(txid).then(() => {
      this.toastr.success('TxID copiado com sucesso!', 'Success', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    }).catch(err => {
      this.toastr.error('Erro ao copiar TxID', 'Error', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    });
  }

}
